/**
 * Author: Thomas Schiela <thomas.schiela@termin2go.com>
 */

(function(angular){
  'use strict';

  var module = angular.module('termin2go-coursebooking', [
    'ui.router',
    'pascalprecht.translate',
    'ngStorage',
    'ngResource',
    'ngSanitize'
  ]);

  var officeResolve = [
    '$q',
    '$stateParams',
    'Storage',
    function($q, $stateParams, Storage){
      var deffered = $q.defer();

      Storage
        .getOfficeData($stateParams.officeSlug)
        .then(
        function(response){
          deffered.resolve(response);
        },
        function(error){
          deffered.reject(error);
        }
      );

      return deffered.promise;
    }
  ];

  var courseResolve = [
    '$q',
    '$stateParams',
    'CourseResource',
    'Storage',
    function($q, $stateParams, CourseResource, Storage){
      var deferred = $q.defer();

      if ($stateParams.range) {
        Storage.setRange($stateParams.range);
      }

      CourseResource.get({officeSlug: $stateParams.officeSlug, date: $stateParams.date, range: $stateParams.range}).$promise.then(
          function(response){
            response.weekKey = moment(response.start).format('YYYY-MM-DD');
            deferred.resolve(response);
          },
          function(error){
            deferred.reject(error);
          }
      );

      return deferred.promise;
    }
  ];


  var courseDetailResolve = [
    '$q',
    '$stateParams',
    'Storage',
    function($q, $stateParams, Storage){
      var deffered = $q.defer();
      var booking = Storage.getBooking();

      Storage
        .getCourseInfo(booking.course)
        .then(
          function(response){
            deffered.resolve(response);
          },
          function(error){
            deffered.reject(error);
          }
      );

      return deffered.promise;
    }
  ];


  var redirectToFirstStep = [
    '$state',
    '$timeout',
    'Storage',
    function($state, $timeout, Storage){

      $timeout(function(){
        if($state.current.name === 'withoutStep'){
          $state.go('courseList', {officeSlug: $state.params.officeSlug});
        } else {
          Storage
            .getOfficeData()
            .then(function(office){
              if(office && office.slug){
                $state.go('courseList', {officeSlug: office.slug});
              }
            });
        }
      });
    }
  ];


  module.constant('CONFIG', {
    API_BASE: 'https://app.termin2go.com/api/v2'
  });

  module.config(['$urlRouterProvider', '$stateProvider', '$translateProvider', '$locationProvider', function($urlRouterProvider, $stateProvider, $translateProvider, $locationProvider){

    $locationProvider.hashPrefix('!');

    //

    $stateProvider
      .state('withoutSlug', {
        url: '!/:officeSlug',
        onEnter: redirectToFirstStep
      })
      .state('withoutStep', {
        url: '/:officeSlug',
        onEnter: redirectToFirstStep
      })
      .state('courseListOld', {
        url: '/:officeSlug/auswahl?:date',
        onEnter: ['$state', '$stateParams', function($state, $stateParams){
          $state.go('courseList', {officeSlug: $stateParams.officeSlug});
        }]
      })
      .state('courseList', {
        url: '/:officeSlug/courses?:date&:range',
        templateUrl: templateUrl + '/views/CourseListView.html',
        controller: 'CourseListCtrl',
        resolve: {
          officeResolve: officeResolve,
          courseResolve: courseResolve
        }
      })
      .state('courseDetail', {
        url: '/:officeSlug/courseDetail',
        templateUrl: templateUrl + '/views/CourseDetailView.html',
        controller: 'CourseDetailCtrl',
        resolve: {
          officeResolve: officeResolve,
          courseDetailResolve: courseDetailResolve
        }
      })
      .state('customerDetails', {
        url: '/:officeSlug/customerDetail',
        templateUrl: templateUrl + '/views/CustomerDetailView.html',
        controller: 'CustomerDetailCtrl',
        resolve: {
          officeResolve: officeResolve,
          courseDetailResolve: courseDetailResolve
        }
      })
      .state('completed', {
        url: '/:officeSlug/completed',
        templateUrl: templateUrl + '/views/CompletedView.html',
        controller: 'CompletedCtrl',
        resolve: {
          officeResolve: officeResolve
        }
      });

    $translateProvider
      .useStaticFilesLoader({
        prefix: templateUrl + '/i18n/',
        suffix: '.json'
      });

    $translateProvider.preferredLanguage('de');

  }]);

})(window.angular);

(function (angular) {

  var module = angular.module('termin2go-coursebooking');


  var TermsModalCtrl = function ($sce,
                                 $scope,
                                 officeResolve,
                                 modalInstance) {

    this.sce_ = $sce;
    this.scope_ = $scope;
    this.scope_.office = officeResolve;
    this.modalInstance_ = modalInstance;
  };
  TermsModalCtrl.$inject = ['$sce', '$scope', 'officeResolve', 'modalInstance'];


  /**
   *
   */
  TermsModalCtrl.prototype.close = function () {
    this.modalInstance_.close();
  };


  /**
   *
   * @returns {String}
   */
  TermsModalCtrl.prototype.getTerms = function(){
    return this.sce_.trustAsHtml(this.scope_.office.profile.conditions);
  };

  module.controller('TermsModalCtrl', TermsModalCtrl);


})(window.angular);

/**
 * Author: Thomas Schiela <thomas.schiela@termin2go.com>
 */

(function(angular, _){
  'use strict';

  var module = angular.module('termin2go-coursebooking');

  module.factory('Storage', ['$q', '$sessionStorage', 'OfficeResource', 'CourseResource', 'BookingResource', function($q, $sessionStorage, OfficeResource, CourseResource, BookingResource){
      var $storage = $sessionStorage.$default({
        courseBooking: {
          office: {},
          courses: [],
          booking: {}
        },
        range: 0
      });

      return {
        reset: function() {
          $storage.courseBooking.booking = {};
        },
        getRange: function() {
          return $storage.range;
        },
        setRange: function(range) {
          $storage.range = range;
        },
        getBooking: function(){
          return $storage.courseBooking.booking;
        },
        getOffice: function(){
          return $storage.courseBooking.office;
        },
        setBooking: function(booking){
          $storage.courseBooking.booking = booking;
        },
        doBooking: function(callback){
          var deferred = $q.defer();
          var booking = new BookingResource($storage.courseBooking.booking);

          booking
            .$save({officeSlug: $storage.courseBooking.office.slug})
            .then(function(response){
              deferred.resolve(response);
            })
            .catch(function(error){
              deferred.reject(error);
            });

          return deferred.promise;
        },
        getOfficeData: function(slug){
          var deferred = $q.defer();

          if(slug && !_.isEmpty($storage.courseBooking.office) && $storage.courseBooking.office.slug !== slug){
            $storage.courseBooking.office = {};
            $storage.courseBooking.booking = {};
            $storage.courseBooking.courses = [];
          }

          if(!_.isEmpty($storage.courseBooking.office)){
            deferred.resolve($storage.courseBooking.office);
          } else {
            OfficeResource.get({officeSlug: slug}).$promise.then(
              function(response){
                $storage.courseBooking.office = response.office;
                deferred.resolve($storage.courseBooking.office);
              },
              function(error){
                deferred.reject(error);
              }
            );
          }

          return deferred.promise;
        },
        getCourseData: function(slug, date){
          var deferred = $q.defer();
          var inStorage = false;
          var startOfWeek = moment(date).startOf('week').format('YYYY-MM-DD');

          // check if week is already stored in session storage
          for(var i = 0, weeks = $storage.courseBooking.courses.length; i < weeks; i++){
            if($storage.courseBooking.courses[i].weekKey === startOfWeek){
              inStorage = true;
              deferred.resolve($storage.courseBooking.courses[i]);
              break;
            }
          }

          if(!inStorage){
            CourseResource.get({officeSlug: slug, date: date}).$promise.then(
              function(response){
                response.weekKey = moment(response.start).format('YYYY-MM-DD');
                $storage.courseBooking.courses.push(response);

                deferred.resolve(response);
              },
              function(error){
                deferred.reject(error);
              }
            );
          }

          return deferred.promise;
        },
        getCourseInfo: function(courseId){
          var deferred = $q.defer();

          this
            .getOfficeData()
            .then(
              function(office){
                var course = _.find(office.courses, {_id: courseId});

                deferred.resolve(course);
              },
              function(error){
                deferred.reject(error);
              }
          );

          return deferred.promise;
        }
      };
    }
  ]);

})(window.angular, window._);

/**
 * Author: Thomas Schiela <thomas.schiela@termin2go.com>
 */

(function(angular){
  'use strict';

  var module = angular.module('termin2go-coursebooking');

  module.directive('onlyNumbers', function () {
    return {
      restrict: 'A',
      require: '?ngModel',
      link: function ($scope, $element, $attributes, $ctrl) {
        var maxlength = $attributes.onlyNumbers ? Number($attributes.onlyNumbers) : null;

        // only allow numeric input
        $element.keydown(function(event) {
          // Allow: delete, backspace, , tab, escape
          if ([46,8,9,27].indexOf(event.keyCode) > -1 ||
              // Allow: Ctrl+A
              (event.keyCode === 65 && event.ctrlKey === true) ||
              // Allow: home, end, left, right
              (event.keyCode >= 35 && event.keyCode <= 39)) {
            return;
          }
          else {
            // Ensure that it is a number and stop the keypress
            if (event.shiftKey || (event.keyCode < 48 || event.keyCode > 57) && (event.keyCode < 96 || event.keyCode > 105 )) {
              event.preventDefault();
            }
          }
        });

        function fromUser(text) {
          if(text && maxlength){
            if (text.length > maxlength) {
              var transformedInput = text.substring(0, maxlength);

              $ctrl.$setViewValue(transformedInput);
              $ctrl.$render();
              return transformedInput;
            }
          }

          return text;
        }

        $ctrl.$parsers.push(fromUser);
      }
    };
  });

})(window.angular);
/**
 * Author: Thomas Schiela <thomas.schiela@termin2go.com>
 */

(function(angular){
  'use strict';

  var module = angular.module('termin2go-coursebooking');

  module.factory('OfficeResource', ['$resource', 'CONFIG', function($resource, CONFIG){
      var resourceUrl = CONFIG.API_BASE + '/office/:officeSlug/bookingProfile';

      var resource = $resource(resourceUrl, {}, {
      });

      return resource;
    }
  ]);

  module.factory('CourseResource', ['$resource', 'CONFIG', function($resource, CONFIG){
      var resourceUrl = CONFIG.API_BASE + '/office/:officeSlug/courses';

      var resource = $resource(resourceUrl, {}, {
      });

      return resource;
    }
  ]);

  module.factory('BookingResource', ['$resource', 'CONFIG', function($resource, CONFIG){
      var resourceUrl = CONFIG.API_BASE + '/office/:officeSlug/courseBooking';

      var resource = $resource(resourceUrl, {}, {
      });

      return resource;
    }
  ]);

})(window.angular);

/**
 * Author: Thomas Schiela <thomas.schiela@termin2go.com>
 */

(function (angular) {
  'use strict';

  var module = angular.module('termin2go-coursebooking');

  module.controller('NavigationCtrl', ['$scope', '$window', '$location', '$timeout', 'Storage', '$sessionStorage', '$stateParams', '$transitions', function ($scope, $window, $location, $timeout, Storage, $sessionStorage, $stateParams, $transitions) {
      $scope.showLoader = false;
      $scope.booking = Storage.getBooking();
      $scope.currentStep = 'courseList';
      $scope.slug = '';
      $scope.pricingStepVisible = false;

      $transitions.onStart({}, function (transition) {
        if (transition.to().resolve) {
          if (transition.from().name === '') {
            $scope.showLoader = true;
          }
        }
      });

      $transitions.onSuccess({}, function(transition) {
        $scope.currentStep = transition.to().name;
        $scope.showLoader = false;
        $scope.slug = $stateParams.officeSlug;
      });

      $transitions.onError({}, function() {
        $scope.showLoader = false;
      });

      $scope.$watch(function () {
        return angular.toJson($sessionStorage.courseBooking);
      }, function () {
        $scope.booking = $sessionStorage.courseBooking.booking;
      });

      $scope.$on('t2g:office-loaded', function () {
        $scope.office = Storage.getOffice();

        if($scope.office && $scope.office.settings) {
          $scope.pricingStepVisible = !$scope.office.settings.disablePriceColumn;
        }
      });
    }
  ]);

})(window.angular);


/**
 * Author: Thomas Schiela <thomas.schiela@termin2go.com>
 */

(function(angular){
  'use strict';

  var module = angular.module('termin2go-coursebooking');

  module.filter('moment', function(){
    return function(dateTime, format){
      return moment(dateTime).format(format);
    };
  });

})(window.angular);

(function (angular) {

  var module = angular.module('termin2go-coursebooking');

  module.factory('ModalService', ['$animate', '$compile', '$controller', '$document', '$injector', '$q', '$rootScope', '$templateRequest', function ($animate,
                                           $compile,
                                           $controller,
                                           $document,
                                           $injector,
                                           $q,
                                           $rootScope,
                                           $templateRequest) {
    /**
     * @param {String} path
     * @return {Promise}
     */
    var getTemplate = function (path) {
      return $templateRequest(path);
    };

    /**
     * @param {Object} resolver
     * @return {Promise}
     */
    var getResolveData = function (resolver) {
      var deferred = $q.defer();
      var resolveValues = {};
      var resolveItems = [];

      angular.forEach(resolver, function (resolve) {
        if (angular.isFunction(resolve) || angular.isArray(resolve)) {
          resolveItems.push($q.resolve($injector.invoke(resolve)));
        } else if (angular.isString(resolve)) {
          resolveItems.push($q.resolve($injector.get(resolve)));
        } else {
          resolveItems.push($q.resolve(resolve));
        }
      });

      $q.all(resolveItems).then(function (resolves) {
        var index = 0;

        angular.forEach(resolver, function (promise, resolveName) {
          resolveValues[resolveName] = resolves[index];
          index++;
        });

        deferred.resolve(resolveValues);
      });

      return deferred.promise;
    };


    return {
      open: function (options) {
        var promises = [getTemplate(options.template)];
        var controller = null;
        var controllerLocals = {
          $scope: $rootScope.$new()
        };
        var bodyElement = $document.find('body');
        var closeDefer = $q.defer();
        var modalInstance = {
          closed: closeDefer.promise
        };

        // resolve promises
        if (options.resolve) {
          promises.push(getResolveData(options.resolve));
        }

        // after resolving promises show modal
        $q
            .all(promises)
            .then(function (response) {
              // create controller instance

              // delete all $promise to avoid merge max call stack error
              for (var promise in response[1]) {
                response[1][promise].$promise = null;
              }

              angular.merge(controllerLocals, response[1]);
              controllerLocals.modalInstance = modalInstance;
              controller = $controller(options.controller, controllerLocals);

              // inject html
              var modalElement = angular.element(response[0]);

              $animate.enter($compile(modalElement)(controllerLocals.$scope), bodyElement)
                  .then(function () {
                    $animate.addClass(bodyElement, 'show-modal');
                  });

              modalInstance.close = function (response) {
                $animate.removeClass(bodyElement, 'show-modal').then(function () {
                  modalElement.remove();
                  controllerLocals.$scope.$destroy();
                  controller = null;
                  closeDefer.resolve(response);
                });
              };
            });

        return modalInstance;
      }
    }
  }]);


})(window.angular);

/**
 * Author: Thomas Schiela <thomas.schiela@termin2go.com>
 */

(function (angular) {
  'use strict';

  var module = angular.module('termin2go-coursebooking');

  module.directive('stateCondition', ['$timeout', function ($timeout) {
      return {
        restrict: 'A',
        priority: 100,
        link: function ($scope, $element, $attributes) {
          $scope.$watch($attributes.stateCondition, function(){
            var condition = $scope.$eval($attributes.stateCondition);

            if(!condition){
              $element.click(function(event) {
                event.preventDefault();
              });
            } else {
              $element
                .unbind('click')
                .click(function() {
                  return true;
                }
              );
            }
          }, true);
        }
      };
    }
  ]);

})(window.angular);
/**
 * Author: Thomas Schiela <thomas.schiela@termin2go.com>
 */

(function (angular) {
  'use strict';

  var module = angular.module('termin2go-coursebooking');

  module.controller('CustomerDetailCtrl', ['$scope', '$window', '$state', '$translate', '$timeout', 'officeResolve', 'ModalService', 'Storage', function ($scope, $window, $state, $translate, $timeout, officeResolve, ModalService, Storage) {
      $scope.office = officeResolve;
      $scope.booking = Storage.getBooking();
      $scope.duration = moment($scope.booking.end).diff($scope.booking.start, 'minutes', true);
      $scope.total = 0;
      $scope.showValidation = false;
      $scope.showLoading = false;
      $scope.checks = {
        data: false,
        terms: false
      };

      $scope.phonePrefixCodes = [
        { name: 'de', prefix: '+49' },
        { name: 'at', prefix: '+43' },
        { name: 'ch', prefix: '+41' },
        { name: 'li', prefix: '+423' },
        { name: 'lu', prefix: '+352' },
        { name: 'es', prefix: '+34' }
      ];

      $scope.booking.customer = {
        salutation: 'm',
        firstname: '',
        lastname: '',
        telephone: ''
      };

      var updatePhoneNumber = function () {
        $scope.booking.customer.telephone = $scope.selectedPhonePrefix + $scope.telephone;
      };

      switch ($scope.office.address.countryCode) {
        case 'DE':
          $scope.selectedPhonePrefix = $scope.phonePrefixCodes[0];
          break;
        case 'AT':
          $scope.selectedPhonePrefix = $scope.phonePrefixCodes[1];
          break;
        case 'CH':
          $scope.selectedPhonePrefix = $scope.phonePrefixCodes[2];
          break;
        case 'LI':
          $scope.selectedPhonePrefix = $scope.phonePrefixCodes[3];
          break;
        case 'LU':
          $scope.selectedPhonePrefix = $scope.phonePrefixCodes[4];
          break;
        case 'ES':
          $scope.selectedPhonePrefix = $scope.phonePrefixCodes[5];
          break;
        default:
          $scope.selectedPhonePrefix = $scope.phonePrefixCodes[0];
      }

      updatePhoneNumber();


      // set price
      if ($scope.booking.offer && $scope.booking.offer.price) {
        $scope.total = $scope.booking.offer.price;
      }

      /**
       * select a phone prefix
       * @param prefix
       */
      $scope.selectPhonePrefix = function (prefix) {
        $scope.selectedPhonePrefix = prefix;
        updatePhoneNumber();
      };


      /**
       * select salutation
       * @param salutation
       */
      $scope.selectSalutation = function (salutation) {
        $scope.booking.customer.salutation = salutation;
      };

      $scope.getDataPrivacyLink = function () {
        var settings = $scope.office.settings;

        if (settings.ownDataPrivacyTerms && settings.dataPrivacyTermsLink) {
          return settings.dataPrivacyTermsLink;
        } else {
          return 'https://www.termin2go.com/datenschutz'
        }
      };

      $scope.getPrivacyHosterName = function () {
        var settings = $scope.office.settings;

        if (settings.ownDataPrivacyTerms && settings.dataPrivacyTermsLink) {
          return $scope.office.name;
        } else {
          return 'Termin2go';
        }
      };

      $scope.openLegalModal = function () {
        var self = this;

        ModalService.open({
          template: templateUrl + '/views/TermsModalView.html',
          controller: 'TermsModalCtrl as TermsModalCtrl',
          resolve: {
            officeResolve: $scope.office
          }
        });
      };


      $scope.book = function () {
        $scope.showValidation = true;
        $scope.showLoading = true;

        if ($scope.CheckoutForm.$valid) {
          // concat telephone number
          $scope.booking.customer.telephone = $scope.selectedPhonePrefix.prefix + $scope.telephone;

          // FE - send valid data to backend
          Storage
            .doBooking()
            .then(function () {
              $state.go('completed', { officeSlug: $scope.office.slug });
              $scope.showLoading = false;
            })
            .catch(function (error) {
              $scope.showLoading = false;
              console.error(error);
            });
        } else {
          $scope.showLoading = false;
        }
      };
    }
  ]);

})(window.angular);




/**
 * Author: Thomas Schiela <thomas.schiela@termin2go.com>
 */

(function (angular) {
  'use strict';

  var module = angular.module('termin2go-coursebooking');

  var getDateRangeString = function (start, end) {
    var start = moment(start);
    var end = moment(end);
    var monthDiff = end.toDate().getMonth() - start.toDate().getMonth();
    var yearDiff = end.toDate().getFullYear() - start.toDate().getFullYear();
    var dateRange = start.format('DD');

    if (monthDiff !== 0) {
      dateRange += ' ' + start.format('MMM');
    }

    if (yearDiff !== 0) {
      dateRange += ', ' + start.format('YYYY');
    }

    dateRange += ' - ' + end.format('DD') + ' ' + end.format('MMM') + ', ' + end.format('YYYY');

    return dateRange;
  };

  module.controller('CourseListCtrl', ['$scope', '$state', '$stateParams', 'officeResolve', 'courseResolve', 'Storage', function ($scope, $state, $stateParams, officeResolve, courseResolve, Storage) {
      var endOfCurrentWeek = moment().endOf('week');
      var paramRange = $stateParams.range || 1;
      var range = paramRange * 7;
      $scope.office = officeResolve;
      $scope.courses = courseResolve;
      $scope.booking = Storage.getBooking();
      $scope.dateRange = getDateRangeString($scope.courses.start, $scope.courses.end);
      $scope.showPrev = false;
      $scope.$emit('t2g:office-loaded');
      $scope.pricingStepVisible = false;

      if($scope.office && $scope.office.settings) {
        $scope.pricingStepVisible = !$scope.office.settings.disablePriceColumn;
      }

      if ($scope.courses.nextCourse) {
        $scope.courses.nextCourseWeek = moment($scope.courses.nextCourse.start).startOf('week').format('YYYY-MM-DD');
      }

      if (parent) {
        parent.postMessage({ type: 'heightChanged', height: document.documentElement.scrollHeight }, '*');
      }

      var changeDate = function (days) {
        var dateString = moment($scope.courses.start).add(days, 'day').format('YYYY-MM-DD');
        $state.go('courseList', { date: dateString });
      };

      $scope.prev = function () {
        changeDate(-range);
      };

      $scope.next = function () {
        changeDate(range);
      };

      // only show previous week btn in future weeks
      if (moment($scope.courses.start).isAfter(endOfCurrentWeek)) {
        $scope.showPrev = true;
      }

      $scope.select = function (appointment) {
        Storage.setBooking(appointment);
        if($scope.pricingStepVisible) {
          $state.go('courseDetail', {officeSlug: $state.params.officeSlug,courseId: appointment.course});
        } else {
          $state.go('customerDetails', {officeSlug: $state.params.officeSlug});
        }
      };
    }
  ]);

})(window.angular);


/**
 * Author: Thomas Schiela <thomas.schiela@termin2go.com>
 */

(function(angular){
  'use strict';

  var module = angular.module('termin2go-coursebooking');

  module.controller('CourseDetailCtrl',['$scope', '$state', 'courseDetailResolve', 'officeResolve', 'Storage', function($scope, $state, courseDetailResolve, officeResolve, Storage){
      $scope.course = courseDetailResolve;
      $scope.office = officeResolve;
      $scope.booking = Storage.getBooking();
      $scope.duration = moment($scope.booking.end).diff($scope.booking.start, 'minutes', true);

      $scope.select = function(offer){
        $scope.booking.offer = offer;
        Storage.setBooking($scope.booking);
        $state.go('customerDetails', {officeSlug: $state.params.officeSlug});
      };
    }
  ]);

})(window.angular);


/**
 * Author: Thomas Schiela <thomas.schiela@termin2go.com>
 */

(function(angular) {
  'use strict';

  var module = angular.module('termin2go-coursebooking');

  module.controller('CompletedCtrl', ['$scope', '$state', 'Storage', 'officeResolve', function($scope, $state, Storage, officeResolve) {
      $scope.office = officeResolve;
      var range = Storage.getRange();

      $scope.goToStart = function() {
        Storage.reset();

        if (range) {
          $state.go('courseList', {officeSlug: $scope.office.slug, range: range});
        } else {
          $state.go('courseList', {officeSlug: $scope.office.slug});
        }
      }
    }
  ]);

})(window.angular);



//# sourceMappingURL=../sourcemaps/app.js.map
